module.exports = __webpack_public_path__ + "img/job_booking11.3b890070.png";